import React, { useEffect, useState } from 'react';
import ObservationTypeEdit from '@awp/components/ObservationTypeAdmin/ObservationTypeEdit';
import ObservationTypeTable from '@awp/components/ObservationTypeAdmin/ObservationTypeTable';
import { BOOTSTRAP_BREAKPOINTS, checkBreakpoint } from '@awp/helpers/UIHelper';
import { GetJson } from '@awp/helpers/fetchReact';
import { REST_API, FORM_MODE } from '@awp/constants';
import { debounce } from '@awp/helpers/Utils';
import { AwpContainer } from '../Common/AwpContainer';
import { DEFAULT_PAGE_SIZE } from '@components/table';

const ObservationTypeAdmin = () => {
  const [mode, setMode] = useState(FORM_MODE.LIST);
  const [isMedium, setIsMedium] = useState(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
  const [isLarge, setIsLarge] = useState(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.LARGE));
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [observationtype, setObservationType] = useState(null);
  const [search, setSearch] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [defaultPageSize, setDefaultPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [categoryDropdownOptions, setCategoryDropdownOptions] = useState([]);

  useEffect(() => {
    setLoading(true);
    let url = REST_API.OBSERVATION_TYPES;
    GetJson(url)
      .then((response) => response.json())
      .then((data) => {
        setData(data);
        setFilteredData(data);
        setLoading(false);
      });

    url = REST_API.DROPDOWNS + REST_API.OBSERVATION_TYPE_CATEGORIES;
    GetJson(url)
      .then((res) => res.json())
      .then((categories) => {
        if (categories != null && categories?.length > 0) {
          const sortCatergories = categories.sort((a, b) => {
            return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
          });
          setCategoryDropdownOptions(sortCatergories);
        }
      });
  }, []);

  useEffect(() => {
    const handleResize = debounce(() => {
      setIsMedium(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
      setIsLarge(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.LARGE));
    }, 100);

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  const tableProps = {
    isMedium,
    isLarge,
    data,
    loading,
    setMode,
    mode,
    setObservationType,
    search,
    setSearch,
    filteredData,
    setFilteredData,
    defaultPageSize,
    setDefaultPageSize,
    categoryDropdownOptions,
  };

  const observationtypeEditProps = {
    setMode,
    mode,
    observationTypeId: observationtype?.Id,
    data,
    setData,
    setLoading,
    loading,
    categoryDropdownOptions,
  };

  return (
    <AwpContainer>
      {mode === FORM_MODE.LIST ? (
        <ObservationTypeTable {...tableProps} />
      ) : (
        <ObservationTypeEdit {...observationtypeEditProps} />
      )}
    </AwpContainer>
  );
};

export default ObservationTypeAdmin;
